import React, {Component} from 'react'
import {observer, inject} from 'mobx-react'
import {Redirect} from 'react-router-dom'
import DocumentTitle from 'react-document-title'
import ReCaptcha from 'react-google-recaptcha'
import {Input, Spin} from 'antd'

import style from './passwordRecovery.sass'

@inject('store') @observer
class PasswordRecovery extends Component {
  state = {passwordFocus: false}
  calculateHeight = () => {
    let footerHeight = 0
    const footer = document.querySelector('footer')
    if (footer) {
      footerHeight = footer.getBoundingClientRect().height
    }
    return window.innerHeight - footerHeight
  }
  handleChange = (e) => {
    const {name, value} = e.target
    this.props.store.auth.change(name, value)
  }
  handleFocus = (e) => {
    this.props.store.auth.removeError(e.target.name)
  }
  handleBlur = (e) => {
    this.props.store.auth.validateField(e.target.name)
  }
  passwordFocus = (e) => {
    this.setState({passwordFocus: true})
    this.handleFocus(e)
  }
  passwordBlur = (e) => {
    this.setState({passwordFocus: false})
    this.handleBlur(e)
  }
  handleSubmit = (e) => {
    e.preventDefault()
    this.props.store.auth.resetPassword()
  }
  handleNewPasswordSubmit = (e) => {
    e.preventDefault()
    const recovery_key = new URLSearchParams(document.location.search).get('recovery_key')
    this.props.store.auth.resetPasswordConfirm(recovery_key)
  }
  handleRecaptcha = (value) => {
    this.props.store.auth.change('recaptcha_response', value)
  }
  render() {
    const {passwordFocus} = this.state
    const {email, password, password_repeat, errors, passwordReset, recaptcha_response, loading} = this.props.store.auth
    const recovery_key = new URLSearchParams(document.location.search).get('recovery_key')
    const captchaComplete = !!recaptcha_response
    if (passwordReset) {
      return <Redirect to='/password-recovery/success'/>
    }
    return(
      <div style={{height:this.calculateHeight()}} styleName='wrapper'>
        <DocumentTitle title='Password Recovery'/>
        <div styleName='banner'/>
        <div styleName='card'>
          {recovery_key &&
            <div>
              <h3>Set new password</h3>
              <p>Enter your e-mail address and new account password below.</p>
              <form styleName='form' onSubmit={this.handleNewPasswordSubmit}>
                <div styleName='field'>
                  <label htmlFor='email'>Email <span>*</span></label>
                  <Input
                    size='large' type='email' name='email'
                    placeholder='E-mail address'
                    value={email}
                    onChange={this.handleChange}
                    styleName={errors.email ? 'has-error' : ''}
                  />
                  {errors.email && <p styleName='error'>{errors.email}</p>}
                </div>
                <div styleName='field'>
                  <label htmlFor='password'>Password <span>*</span></label>
                  <Input
                    size='large'
                    type='password'
                    name='password'
                    value={password}
                    onChange={this.handleChange}
                    onBlur={this.passwordBlur}
                    onFocus={this.passwordFocus}
                    styleName={errors.password ? 'has-error' : ''}
                  />
                  {passwordFocus && <p styleName='error' style={{color: 'inherit'}}>Password must be at least 10 characters, and contain at least 1 digit, 1 letter and 1 special character</p>}
                  {!passwordFocus && errors.password && <p styleName='error'>{errors.password}</p>}
                </div>
                <div styleName='field'>
                  <label htmlFor='password2'>Confirm password <span>*</span></label>
                  <Input
                    size='large'
                    type='password'
                    name='password_repeat'
                    value={password_repeat}
                    onChange={this.handleChange}
                    onBlur={this.handleBlur}
                    onFocus={this.handleFocus}
                    styleName={errors.password_repeat ? 'has-error' : ''}
                  />
                  {errors.password_repeat && <p styleName='error'>{errors.password_repeat}</p>}
                </div>
                <div styleName='captcha-wrapper'>
                  <ReCaptcha
                    sitekey='6LcQVmUUAAAAAEJaWtdSFswV-iFmsV6j61gHiqTm'
                    onChange={this.handleRecaptcha}
                  />
                </div>
                <div styleName='button'>
                  <button type='submit' styleName={loading ? 'loading' : ''} disabled={loading || !captchaComplete}>
                    {loading ? <Spin size='small' styleName='spin'/> : 'Reset My Password'}
                  </button>
                </div>
              </form>
            </div>
          }

          {!recovery_key &&
            <div>
              <h3>Forgotten your password?</h3>
              <p>Enter your e-mail address below, and we&apos;ll send you an e-mail allowing you to reset it.</p>
              <form styleName='form' onSubmit={this.handleSubmit}>
                <Input
                  size='large' type='email' name='email'
                  placeholder='E-mail address'
                  value={email}
                  onChange={this.handleChange}
                />
                <div styleName='captcha-wrapper'>
                  <ReCaptcha
                    sitekey='6LcQVmUUAAAAAEJaWtdSFswV-iFmsV6j61gHiqTm'
                    onChange={this.handleRecaptcha}
                  />
                </div>
                <div styleName='button'>
                  <button type='submit' styleName={loading ? 'loading' : ''} disabled={loading || !captchaComplete}>
                    {loading ? <Spin size='small' styleName='spin'/> : 'Reset My Password'}
                  </button>
                </div>
              </form>
            </div>
          }
          <p>Please contact us if you have any trouble resetting your password.</p>
        </div>
      </div>
    )
  }
}

export default PasswordRecovery
